export const cookieDomain = () =>
  window.location.hostname === "localhost"
    ? undefined
    : window.location.hostname.includes("edx.org")
      ? window.location.hostname === "stage.edx.org" ||
        window.location.hostname.startsWith("stage.")
        ? `.stage.edx.org`
        : `.edx.org`
      : undefined;
